export const classTargetMap: Record<
  string,
  {
    target: "roadClasses" | "borderAreaRightClasses" | "borderAreaLeftClasses";
    customTarget: "mainCustomClass" | "rightBorderCustomClass" | "leftBorderCustomClass";
  }
> = {
  RoadMClasses: { target: "roadClasses", customTarget: "mainCustomClass" },
  RoadPClasses: { target: "roadClasses", customTarget: "mainCustomClass" },
  RoadCClasses: { target: "roadClasses", customTarget: "mainCustomClass" },
  BorderAreaRightCClasses: { target: "borderAreaRightClasses", customTarget: "rightBorderCustomClass" },
  BorderAreaRightPClasses: { target: "borderAreaRightClasses", customTarget: "rightBorderCustomClass" },
  BorderAreaLeftCClasses: { target: "borderAreaLeftClasses", customTarget: "leftBorderCustomClass" },
  BorderAreaLeftPClasses: { target: "borderAreaLeftClasses", customTarget: "leftBorderCustomClass" },
};
